import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { BaseModalType } from '@context/ModalsContext'

import { Body1 } from '@ui/Typography'
import { Modal } from '@ui/components/Modal'

import { CommonPaths } from '@utils/path-common'

import { PlatformInfoDto } from '@model/PlatformInfoDto'
import { PlatformTypeEnum, getPlatformType } from '@model/PlatformTypeEnum'

import { usePlatformDownloadLinksData } from '../platformsLearnMoreData'

interface MissingAccountModalProps {
  platformInfo: PlatformInfoDto[]
}

export const MissingAccountModal: BaseModalType<MissingAccountModalProps> = (props) => {
  const { platformInfo, close } = props

  const { t } = useTranslation()
  const navigate = useNavigate()

  const { webTraderLink } = usePlatformDownloadLinksData(platformInfo)

  const handleAccountClick = () => {
    navigate(CommonPaths.NewLiveTradingAccount, {
      state: {
        platformType: getPlatformType(PlatformTypeEnum.TickmillTrader),
      },
    })
    close()
  }

  const handleWebTraderClick = () => {
    webTraderLink && window.open(webTraderLink, '_blank')
  }

  return (
    <Modal>
      <Modal.Header>{t('ToolsPlatforms.Looks Like Youre Missing an Account')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <Body1 isParagraph>
            {t('ToolsPlatforms.To access the WebTrader, you need a Tickmill Trader account')}
          </Body1>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Primary onClick={handleAccountClick}>
          {t('ToolsPlatforms.Open Account')}
        </Modal.Footer.Primary>
        <Modal.Footer.Primary onClick={handleWebTraderClick}>
          {t('ToolsPlatforms.Open WebTrader')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
